import Logger from '@diziner/Logger';
import { Events } from '@diziner/Events';
/**
 * @todo Cache document.queries to vars, 10us each
 */
export class NavigationMenu {
    constructor(issue) {
        this.elNavMenuButton = null;
        this.elPtMain = null;
        this.elNavWrapper = null;
        this.issue = issue;
        this.elNavMenuButton = document.getElementById('tmb_nav_button_menu');
        this.elPtMain = document.getElementById('pt-main');
        this.elNavWrapper = document.getElementById('tmb_nav_wrapper');
        this.registerEventListeners();
    }
    static async updateCurrentPageNumber(index) {
        const listener = document.
            getElementById('current_page_pagination');
        if (listener !== null) {
            listener.textContent = ((index || 0) + 1).toString();
        }
    }
    async handlePreviousPageClick() {
        if (this.issue.vars.navigating)
            return;
        return this.issue.navigateToPreviousPage();
    }
    async handleNextPageClick() {
        if (this.issue.vars.navigating)
            return;
        return this.issue.navigateToNextPage();
    }
    async menuToggle() {
        this.elPtMain?.classList.toggle('open');
        this.elNavWrapper?.classList.toggle('open');
        this.elNavMenuButton?.classList.toggle('open');
    }
    async open() {
        this.elPtMain?.classList.add('open');
        this.elNavWrapper?.classList.add('open');
        this.elNavMenuButton?.classList.add('open');
    }
    async close() {
        this.elPtMain?.classList.remove('open');
        this.elNavWrapper?.classList.remove('open');
        this.elNavMenuButton?.classList.remove('open');
    }
    async updateMenuPosition() {
        Logger.instance.debug('updateMenuPosition');
        Logger.instance.time('updateMenuPosition');
        const menuItems = document.querySelectorAll('.magazine-menu li.page_item');
        let currentMenuItem;
        menuItems.forEach((menuItem) => {
            const currentPageId = menuItem.getAttribute('data-pageid');
            if (currentPageId !== null && parseInt(currentPageId) ===
                this.issue.pages[this.issue.vars.currentPageIndex]?.pageId) {
                currentMenuItem = menuItem;
                menuItem.classList.add('current_page_item');
            }
            else {
                menuItem.classList.remove('current_page_item');
            }
        });
        if (currentMenuItem) {
            const menuUl = currentMenuItem.closest('ul.magazine-menu');
            const $menuUl = jQuery(menuUl);
            $menuUl.animate({
                scrollLeft: menuUl.scrollLeft +
                    (currentMenuItem.getBoundingClientRect().left -
                        (menuUl.clientWidth / 2)) +
                    (currentMenuItem.clientWidth / 2),
            });
        }
        Logger.instance.timeEnd('updateMenuPosition');
    }
    registerEventListeners() {
        document.addEventListener('click', this.maybeClickOutsideOfMenu.bind(this));
        this.elNavMenuButton?.addEventListener('click', this.menuToggle.bind(this));
        const menuItems = document.querySelectorAll('#tmb_menu ul.magazine-menu li[data-pageid]');
        menuItems.forEach((menuItem) => {
            menuItem.addEventListener('click', (event) => {
                this.menuItemClick(event);
            });
            // Disable navigation on anchors
            menuItem.querySelector('a:not(.edit-page)')?.
                addEventListener('click', (event) => {
                event.preventDefault();
            });
        });
        document.getElementById('tmb_nav_button_left')?.
            addEventListener('click', this.handlePreviousPageClick.bind(this));
        document.getElementById('tmb_nav_button_right')?.
            addEventListener('click', this.handleNextPageClick.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
        Events.Issue.UpdatePageIndex.subscribe(this.updateMenuPosition.bind(this));
    }
    menuItemClick(event) {
        const target = event.target;
        if (target.closest('a.edit-page') !== null) {
            return;
        }
        const li = event.currentTarget;
        const pageId = parseInt(li.getAttribute('data-pageid') ?? '0');
        Logger.instance.debug('menuItemClick - pageId: ' + pageId);
        if (pageId > 0) {
            const pageIndex = this.issue.getPageIndexById(pageId);
            if (pageIndex === this.issue.vars.currentPageIndex) {
                Logger.instance.debug('menuItemClick - returning since current and target index are equal');
                return;
            }
            (pageIndex !== null &&
                this.issue.navigateToPageIndex(pageIndex).
                    catch(() => {
                    return;
                }));
        }
    }
    async handleKeyDown(event) {
        Logger.instance.debug('handleKeyDown: ' + event.code);
        const lightboxMessage = document.querySelector('.dialog-lightbox-message');
        //Disable keys for diziner when lightbox is open.
        if (lightboxMessage && lightboxMessage.children.length > 0) {
            return;
        }
        if (document.querySelector('.elementor-lightbox > .dialog-widget-content .swiper-container-initialized') !== null) {
            return;
        }
        if (event.code === 'Escape') {
            return this.close();
        }
        if (this.issue.vars.navigating === false) {
            if (event.code === 'ArrowLeft') {
                return this.issue.navigateToPreviousPage();
            }
            if (event.code === 'ArrowRight') {
                return this.issue.navigateToNextPage();
            }
        }
    }
    maybeClickOutsideOfMenu(event) {
        const target = event.target;
        if (target.closest('#tmb_nav_wrapper') === null) {
            this.close();
        }
    }
}
export default NavigationMenu;
